import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

const Footer: React.FC = () => {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">
                福
              </span>
              <span className="text-lg font-heading font-bold text-foreground-900 whitespace-nowrap">
                福利铺子
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              海量福利优惠一站汇聚，让您轻松享受实实在在的省钱福利。每日精选福利资源，好福利不错过！
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4 text-sm">
              福利分类
            </h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4 text-sm">
              快捷链接
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/"
                className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
              >
                首页
              </Link>
              <Link
                to="/about"
                className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
              >
                关于我们
              </Link>
              <a
                href="#faq"
                className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
              >
                常见问题
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4 text-sm">
              联系我们
            </h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-600">
              <p className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </span>
                contact@fulipuzi.com
              </p>
              <p className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line"></i>
                </span>
                400-888-6666
              </p>
              <p className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line"></i>
                </span>
                北京市朝阳区建国路88号
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between max-w-7xl mx-auto gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2025 福利铺子 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-600 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-primary-600 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="hover:text-primary-600 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;